import { createBrowserRouter } from 'react-router-dom';
import { PublicLayout } from '../components/PublicLayout/PublicLayout';
import { LandingPage } from '../pages/LandingPage/LandingPage';
import { RequestPage } from '../pages/RequestPage/RequestPage';
import { BatchRequestPage } from '../pages/BatchRequestPage/BatchRequestPage';
import { ExpiredPage } from '../pages/ExpiredPage/ExpiredPage';
import { NotFoundPage } from '../pages/NotFoundPage/NotFoundPage';
import { SupportPage } from '../pages/SupportPage/SupportPage';
import { PrivacyPage } from '../pages/PrivacyPage/PrivacyPage';
import { PreferencesPage } from '../pages/PreferencesPage/PreferencesPage';
import { SharedRequestsPage } from '../pages/SharedRequestsPage/SharedRequestsPage';
import { AuthCallbackPage } from '../pages/AuthCallbackPage/AuthCallbackPage';
import { PricingPage } from '../pages/PricingPage/PricingPage';
import { TermsPage } from '../pages/TermsPage/TermsPage';
import { SubscriptionSuccessPage } from '../pages/SubscriptionSuccessPage/SubscriptionSuccessPage';
import { SubscriptionCancelledPage } from '../pages/SubscriptionCancelledPage/SubscriptionCancelledPage';
import { AdminRoute } from '../pages/admin/components/AdminRoute';
import { AdminLayout } from '../pages/admin/AdminLayout';
import { OverviewPage } from '../pages/admin/overview/OverviewPage';
import { UsersPage } from '../pages/admin/users/UsersPage';
import { UserDetailPage } from '../pages/admin/users/UserDetailPage';
import { SubscriptionsPage } from '../pages/admin/subscriptions/SubscriptionsPage';

export const router = createBrowserRouter([
  {
    element: <AdminRoute />,
    children: [
      {
        path: '/admin',
        element: <AdminLayout />,
        children: [
          { index: true, element: <OverviewPage /> },
          { path: 'users', element: <UsersPage /> },
          { path: 'users/:id', element: <UserDetailPage /> },
          { path: 'subscriptions', element: <SubscriptionsPage /> },
        ],
      },
    ],
  },
  {
    element: <PublicLayout />,
    children: [
      { path: '/', element: <LandingPage /> },
      { path: '/pricing', element: <PricingPage /> },
      { path: '/support', element: <SupportPage /> },
      { path: '/privacy', element: <PrivacyPage /> },
      { path: '/terms', element: <TermsPage /> },
      { path: '/shared-requests', element: <SharedRequestsPage /> },
      { path: '/preferences', element: <PreferencesPage /> },
      { path: '/r/:id', element: <RequestPage /> },
      { path: '/b/:id', element: <BatchRequestPage /> },
      { path: '/expired', element: <ExpiredPage /> },
      { path: '/subscription/success', element: <SubscriptionSuccessPage /> },
      { path: '/subscription/cancelled', element: <SubscriptionCancelledPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
  {
    path: '/auth/callback',
    element: <AuthCallbackPage />,
  },
]);
